import { render, staticRenderFns } from "./kindChooseView.vue?vue&type=template&id=e3ef4c6e&scoped=true"
import script from "./kindChooseView.vue?vue&type=script&lang=js"
export * from "./kindChooseView.vue?vue&type=script&lang=js"
import style0 from "./kindChooseView.vue?vue&type=style&index=0&id=e3ef4c6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef4c6e",
  null
  
)

export default component.exports